import React, { useContext } from "react";

import {
  Alert,
  Button,
  CardContent,
  CircularProgress,
  Snackbar,
} from "@mui/material";
import { Stack } from "@mui/system";

import { ActionType } from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/action_pb";

import { DEFAULT_SNACKBAR_DURATION } from "../../../../constants/index";
import { PermissionsContext } from "../../../../context/permissions-context";
import SettingsMonitoringConfirmDialog from "./monitoring-confirm-dialog";
import SettingsMonitoringTable from "./monitoring-table";
import { SettingsContext } from "./settings-context";

const SettingsMonitoring = () => {
  const { hasPermissions, permissions } = useContext(PermissionsContext);
  const canUpdateLoneWorkerSettings =
    !permissions.isPermissionsLoading &&
    hasPermissions([ActionType.UPDATE_LONEWORKER_ORG_SETTINGS]);

  const {
    isSnackbarOpen,
    setIsOpenConfirmDialog,
    setIsSnackbarOpen,
    isSaving,
  } = useContext(SettingsContext);

  return (
    <>
      <SettingsMonitoringTable />
      <CardContent>
        <Stack width="fit-content">
          <Button
            color="primary"
            variant="contained"
            type="button"
            onClick={() => {
              setIsOpenConfirmDialog(true);
            }}
            data-testid="submit-button"
            disabled={!canUpdateLoneWorkerSettings || isSaving}
          >
            {isSaving ? (
              <CircularProgress
                color="inherit"
                style={{ height: "24px", width: "24px" }}
              />
            ) : (
              <>Save</>
            )}
          </Button>
        </Stack>
      </CardContent>
      <SettingsMonitoringConfirmDialog />
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        open={isSnackbarOpen}
        autoHideDuration={DEFAULT_SNACKBAR_DURATION}
        onClose={() => setIsSnackbarOpen(false)}
        data-testid="saved-successfully-snackbar"
      >
        <Alert severity="success" variant="filled">
          Saved successfully
        </Alert>
      </Snackbar>
    </>
  );
};

export default SettingsMonitoring;
